import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { useLanguage, type Language } from '../../contexts/LanguageContext';
import { spring } from '../../utils/motion';
const options: {
  value: Language;
  label: string;
  name: string;
}[] = [{
  value: 'en',
  label: 'EN',
  name: 'English'
}, {
  value: 'th',
  label: 'ไทย',
  name: 'ภาษาไทย'
}];
export function LanguageSwitcher({
  id,
  className
}: {
  id: string;
  className?: string;
}) {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div role="radiogroup" aria-label="Language" className={twMerge('inline-flex shrink-0 rounded-full bg-surface-2 p-0.5', className)} data-id="element-790" data-mp="ftqzptdrczak">
      {options.map(o => {
      const active = lang === o.value;
      return <button key={o.value} type="button" role="radio" aria-checked={active} aria-label={o.name} onClick={() => setLang(o.value)} className={twMerge('relative h-8 min-w-[38px] rounded-full px-2 text-xs font-bold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand', active ? 'text-ink' : 'text-ink-3 hover:text-ink-2')} data-id="element-791" data-mp="poixax7cbm5c">
            {active && <motion.span layoutId={`lang-${id}`} transition={spring.snappy} className="absolute inset-0 rounded-full bg-surface shadow-[0_1px_4px_rgb(0_0_0/0.1)]" data-id="element-792" data-mp="3aeod86h3gxft" />}
            <span className="relative" data-id="element-793" data-mp="2imz4izxm5np6">{o.label}</span>
          </button>;
    })}
    </div>;
}